import useReveal from "../hooks/useReveal";
import Seo from "../components/Seo";

const TEXTURE = "https://static.prod-images.emergentagent.com/jobs/1f9c6200-ca73-4c9b-a307-361cf054655d/images/4b45544fb2792344fcd310d09e88872a4281e4d33367f209810db61c9bae9299.png";
const CRANE = "https://images.pexels.com/photos/8961065/pexels-photo-8961065.jpeg?auto=compress&cs=tinysrgb&w=1600";

export default function About() {
  useReveal();
  return (
    <div data-testid="about-page">
      <Seo title="About" description="B7 Search & Selection — 18 years recruiting specialist construction and infrastructure talent across the UK, Europe and the Middle East." path="/about" />

      <section className="max-w-7xl mx-auto px-6 sm:px-10 pt-32 pb-16">
        <div className="overline">About</div>
        <h1 className="font-serif text-5xl sm:text-7xl lg:text-8xl leading-[0.95] tracking-tight mt-6 max-w-5xl" data-testid="about-headline">
          Bespoke recruitment for an industry that <span className="italic text-[#1E2A78]">builds the future</span>.
        </h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 sm:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 pb-24">
        <div className="lg:col-span-7 reveal">
          <img src={CRANE} alt="Construction" className="w-full h-[520px] object-cover" />
        </div>
        <div className="lg:col-span-5 reveal flex flex-col justify-center">
          <p className="text-lg leading-relaxed text-[#222]">
            With 18 years recruiting across the UK, Europe and the Middle East, the team at B7
            Search &amp; Selection specialise in providing efficient, considered hiring outcomes
            for the construction and infrastructure sector.
          </p>
          <p className="text-lg leading-relaxed text-[#222] mt-6">
            We know a resume is important — but it's our job as consultants to understand the
            people behind it, and the precise needs of the employer.
          </p>
        </div>
      </section>

      <section className="bg-white border-y border-[#E2E0D9] py-16" data-testid="about-stats">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            ["18+", "Years specialist"],
            ["£100M+", "Project value placed across"],
            ["5", "Disciplines covered"],
          ].map(([n, l]) => (
            <div key={l} className="border-t-2 border-[#2EA3F2] pt-6">
              <div className="font-serif text-5xl sm:text-6xl tracking-tight">{n}</div>
              <div className="overline mt-3">{l}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 sm:px-10 py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="overline">How we work</div>
            <h2 className="font-serif text-4xl sm:text-5xl mt-6 leading-tight">A deliberate, four-stage process.</h2>
          </div>
          <div className="lg:col-span-7 lg:col-start-6 space-y-10">
            {[
              ["01", "Brief", "We invest the time to understand the project, culture, and the commercial reality of the role."],
              ["02", "Search", "Discreet, targeted outreach across our long-standing network plus rigorous market mapping."],
              ["03", "Shortlist", "Side-by-side comparisons with objective consultant commentary — not just CVs."],
              ["04", "Hire", "Offer management, onboarding support, and long-term aftercare for both sides."],
            ].map(([n, t, d]) => (
              <div key={n} className="grid grid-cols-12 gap-6 border-b border-[#E2E0D9] pb-8">
                <div className="col-span-2 overline">{n}</div>
                <div className="col-span-10">
                  <h3 className="font-serif text-2xl">{t}</h3>
                  <p className="text-sm text-[#5C5C5C] mt-2 leading-relaxed">{d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        className="relative py-32 bg-cover bg-center"
        style={{ backgroundImage: `url(${TEXTURE})` }}
      >
        <div className="absolute inset-0 bg-[#0E1530]/92" />
        <div className="relative max-w-3xl mx-auto px-6 text-center text-white">
          <div className="overline-light">Our ethos</div>
          <p className="font-serif text-3xl sm:text-5xl leading-tight mt-6 italic">
            "The right hire is rarely the most obvious one. It's the one that endures."
          </p>
        </div>
      </section>
    </div>
  );
}
